(function(angular){
	'use strict';
	
	angular
		.module('verifyPasswordModule', [
			'coreModule',
			'formValidationModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);